import { homePageCover } from '@/utils/mysqTools'

const state = {
  // 状态数据
  parent_node: [
    {
      id: 31,
      title: '美甲手图',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/31%E5%9C%A3%E8%AF%9E%E7%BE%8E%E7%94%B2/31.png',
      show: true,
      property: 'SD 1.5',
      date: '2025-11-17'
    },
    {
      id: 30,
      title: '美甲手图',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/30%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2V0.7/030.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-10-25'
    },
    {
      id: 29,
      title: '美甲手图',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/29%E9%80%9A%E7%94%A8%E5%9B%BE%E5%BA%93/common.png',
      show: true,
      property: 'Flux',
      date: '2025-10-20'
    },
    {
      id: 28,
      title: '美甲手图',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/28%E9%BB%91%E6%89%8B%E5%9B%BE/001.png',
      show: true,
      property: 'Flux',
      date: '2025-10-15'
    },
    {
      id: 27,
      title: '美甲手图',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/27%E7%8C%AB%E7%9C%BC%E7%94%B2%E7%89%87/maoyan.png',
      show: true,
      property: 'Flux',
      date: '2025-09-25'
    },
    {
      id: 26,
      title: '美甲手图',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/26%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2%5B%E8%87%AA%E7%A0%94V0.7%5D/shoutu02.png',
      show: true,
      property: 'SDXL',
      date: '2025-09-20'
    },
    {
      id: 25,
      title: '美甲手图',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/25%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2%5B%E8%87%AA%E7%A0%94V1.0%5D/shoutu01.png',
      show: true,
      property: 'SDXL',
      date: '2025-09-18'
    },
    {
      id: 24,
      title: '美甲手图',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/24%E9%80%9A%E7%94%A8%E7%BE%8E%E7%94%B2%5B%E8%87%AA%E7%A0%94%5D/768x1024_03.png',
      show: true,
      property: 'SDXL',
      date: '2025-09-15'
    },
    {
      id: 17,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/17%20%E7%8E%BB%E7%92%83%E7%AB%8B%E6%96%B9%E4%BD%93/%E7%94%BB%E6%9D%BF%201%20%E6%8B%B7%E8%B4%9D%2013.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-09-14'
    },
    {
      id: 18,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/18%20%E6%B0%B4%E4%B8%AD%E5%9C%BA%E6%99%AF/%E7%94%BB%E6%9D%BF%201%20%E6%8B%B7%E8%B4%9D%2014.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-09-13'
    },
    {
      id: 19,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/19%20%E6%B0%B4%E6%B3%A2%E6%91%84%E5%BD%B1/%E7%94%BB%E6%9D%BF%201%20%E6%8B%B7%E8%B4%9D%2015.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-09-09'
    },
    {
      id: 20,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/20%20%E7%A7%91%E7%A0%94%E6%97%B6%E9%92%9F/%E7%94%BB%E6%9D%BF%201%20%E6%8B%B7%E8%B4%9D%2016.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-09-07'
    },
    {
      id: 21,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/21%20%E5%AE%A4%E5%A4%96%E6%B3%B3%E6%B1%A0/%E7%94%BB%E6%9D%BF%201%20%E6%8B%B7%E8%B4%9D%2018.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-09-05'
    },
    {
      id: 22,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/22%20%E5%AE%9E%E9%AA%8C%E5%AE%A4/%E7%94%BB%E6%9D%BF%201%20%E6%8B%B7%E8%B4%9D%2019.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-09-03'
    },
    {
      id: 23,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/23%E8%BF%90%E5%8A%A8%E5%9C%BA%E6%99%AF/%E7%94%BB%E6%9D%BF%201%20%E6%8B%B7%E8%B4%9D%2017.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-08-29'
    },
    {
      id: 16,
      title: '通用美甲',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/16%E9%80%9A%E7%94%A8%E7%94%B2%E7%89%87/parent_node2.png',
      show: true,
      property: 'SD 1.5',
      date: '2025-08-27'
    },
    {
      id: 14,
      title: '欧美模特',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/014%E6%AC%A7%E7%BE%8E%E5%A5%B3%E7%94%9F/parent_node.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-08-25'
    },
    {
      id: 15,
      title: '欧美模特',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/template_cover/015%E6%AC%A7%E7%BE%8E%E4%BF%8F%E7%9A%AE/parent_node1.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-08-22'
    },
    {
      id: 0,
      title: '非裔黑人模特',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/000.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-08-21'
    },
    {
      id: 1,
      title: '欧美白人模特',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/001.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-08-18'
    },
    {
      id: 2,
      title: '果冻胶美甲',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/002.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-08-17'
    },
    {
      id: 3,
      title: '国风美甲',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/003.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-08-13'
    },
    {
      id: 4,
      title: '创意美甲',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/004.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-08-05'
    },
    {
      id: 5,
      title: '细闪美甲',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/005.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-07-25'
    },
    {
      id: 6,
      title: '电商主图No1',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/006.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-07-15'
    },
    {
      id: 7,
      title: 'INS风美甲',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/007.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-07-05'
    },
    {
      id: 8,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/008.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-07-08'
    },
    {
      id: 9,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/009.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-07-06'
    },
    {
      id: 10,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/010.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-06-20'
    },
    {
      id: 11,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/011.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-06-11'
    },
    {
      id: 12,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/012.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-06-03'
    },
    {
      id: 13,
      title: '电商海报',
      img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/parante_node_cover/013.png',
      show: true,
      property: 'Lora F.1',
      date: '2025-06-02'
    }
  ],
  homePageCover: []
}

const mutations = {
  updateHomePageCover(state, res) {
    // state.homePageCover = state.parent_node
    res.tables.forEach(items => {
      const obj = {
        id: null,
        title: '',
        img: '',
        show: true,
        property: ''
      }
      obj.id = items[0]
      obj.title = items[1]
      obj.img = items[2]
      obj.show = items[3]
      obj.property = items[4]
      const exists = state.homePageCover.some(item => item.id === obj.id)
      if (!exists) {
        state.homePageCover.push(obj)
      }
    })
  }
}

const actions = {
  async selectTable(context) {
    try {
      const res = await homePageCover()
      context.commit('updateHomePageCover', res)
    } catch (error) {
      console.error('首页封面数据加载失败:', error)
    }
  }
}

const getters = {
  sourceHomePageCover: (state) => {
    return state.homePageCover
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
